//import $ from 'jquery';

import { View } from 'backbone';
import { Model } from 'backbone';
import util from 'util/Util.js';
import sequenceService from 'SequenceService'
import listService  from 'ListService.js';
import template from 'common-views/formula/formula-modal.ejs';
import groupTemplate from 'common-views/formula/group-item.ejs';
import functionTemplate from 'common-views/formula/function.ejs';
import selectFieldModal from 'common-views/SelectFieldModalView';
import formulaService       from 'xml/FormulaService.js';
import specialFormList from 'SpecialFormList.js';
import namesUtil from 'util/NamesUtil.js'
import Moment from 'moment';
import constants from 'Constants.js';

class MainFormulaModalView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;
        this.FORMULA_LIST = '#formulaList';
        this.formulaExpression = [];
        this.selectedItem = '';
        this.selectedItemId = '';
        this.ARGUMENT = 'argument';
        this.OPERATOR = 'operator';
        this.GROUPING = 'grouping';
        this.FUNCTION = 'function';
        this.BLANK    = 'blank';
        this.EMPTY    = '[empty]';
        this.lastSelectedField = {id: '', name: ''};
        this.multiSelectItemArray = [];
        this.IS_CHART = false;
        this.cleanIds = [];

        const formulaExpressionArray = this.model.has('formulaParameter') ? this.model.get('formulaParameter').arguments: [];    
        this.fixDuplicatedIds(formulaExpressionArray);

        this.events = {
            'change input[type=radio]' : 'updateRadioAttributes'
        };
        if( util.isChart(this.model.get('factoryKey')) || this.model.get('type') === 'DataSource' ){        
            this.IS_CHART = true;
        }

        if(!this.model.get('type')){
          this.model.set('type','Formula',{silent:true} );
        }

        let typeInit = 'scripting_literal';
        if(this.model.get('type') && this.model.get('type') === 'DataSource'){
            typeInit = 'scripting_literal_text'
        }

        if(!this.model.get('formulaType') || this.model.get('formulaType') === 'formulaParameter'){
            if (this.model.get('formulaParameter') && this.model.get('formulaParameter').arguments) {
                if (this.model.get('formulaParameter').arguments.length === 0) {
                    this.formulaExpression = [{id: sequenceService.nextDomId(), kind: 'argument', type: typeInit, fieldId: '', value: '[empty]'}]
                } else {
                    // clone so we don't get it by ref
                    this.formulaExpression = JSON.parse( JSON.stringify( this.model.get('formulaParameter').arguments ));
                }
            } else {
                this.formulaExpression = [{id: sequenceService.nextDomId(), kind: 'argument', type: typeInit, fieldId: '', value: '[empty]'}]
            }
        } else if (this.model.get('formulaType') === 'groupFormula' || this.model.get('formulaType') === 'valueFormula' || 
                   this.model.get('formulaType') === 'sideFormula' || this.model.get('formulaType') === 'typeFormula') {
            let formType = this.model.get('formulaType');
            if (this.model.get(formType) && this.model.get(formType).arguments) {
                if (this.model.get(formType).arguments.length === 0) {
                    this.formulaExpression = [{id: sequenceService.nextDomId(), kind: 'argument', type: typeInit, fieldId: '', value: '[empty]'}]
                } else {
                    this.formulaExpression = JSON.parse( JSON.stringify( this.model.get(formType).arguments ));
                }
            } else {
                this.formulaExpression = [{id: sequenceService.nextDomId(), kind: 'argument', type: typeInit, fieldId: '', value: '[empty]'}]
            }
        } else {
            this.formulaExpression = [{id: sequenceService.nextDomId(), kind: 'argument', type: typeInit, fieldId: '', value: '[empty]'}]
        }

        if (!this.model.get('title')) {
            if(this.model.get('type') && this.model.get('type') === 'DataSource'){
                this.model.attributes.title = 'Data-Source Filter';
            }else{
                this.model.attributes.title = 'Compose Formula';
            }
        }

        this.formulaExpression.push({id: sequenceService.nextDomId(), kind: 'blank', type: 'blank', fieldId: '', value: '&nbsp;'});

        if (this.formulaExpression) {
            this.fixUpFields(this.formulaExpression);
        }

        var workflowArray = [];
        var workflowStages = listService.getWorkflowStages();
        workflowStages.map(function (val, key) {
            var item = { text: 'Workflow - Stage "' +val.model.get('name') + '"', value: 'workflowstage_'+ val.model.get('id') };
            workflowArray.push(item);
        });

        if (this.model.get('type') !== 'DataSource') {
            this.model.set('specialInstance', specialFormList.getSpecialFormList().concat(workflowArray), {silent:true} );
        } else {
                this.model.set('specialInstance', [], { silent:true });
                if (this.model.get('dataSourceId') && this.model.get('dataSourceId') !== 'none') {
                    const datasource = listService.getDataSources(listService.cleanId(this.model.get('dataSourceId')));
                    if(this.IS_CHART) {
                        this.model.set('specialInstance', specialFormList.getChartlDataSourceList(datasource.Fields), {silent:true} );
                    }else{
                        this.model.set('specialInstance', specialFormList.getSpecialDataSourceList(datasource.Fields), {silent:true} );
                    }
                }
                else if (this.model.get('dataSource')) {
                    this.model.set('specialInstance', specialFormList.getSpecialDataSourceList(this.model.get('dataSource')), { silent: true} );
                }
        }

        this.model.set('specialInstance', this.model.get('specialInstance').map(item=>{
            return {
                text: item.text,
                value: item.value,
                translated: util.changeNameFields(item.text),
                dataType: item.dataType
            }
        }), constants.MODEL_SILENT );

        return this;
    }

    isDataSource(){
        return this.model.get('type') && this.model.get('type') === 'DataSource';
    }

    fixDuplicatedIds(formulaExpressionArray) {
            
        let found = false;
        let self = this;
        _.forEach(formulaExpressionArray, function(item, id) {

            if(item.children){
                self.fixDuplicatedIds(item.children);
            }

            found = self.cleanIds.find(function(element) {
              return item.id === element;
            });
            if (!found) {
                self.cleanIds.push(item.id);
            } else {
                item.id = sequenceService.nextDomId();
            }
        });
    }

    fixUpFields(expression) {
        const self = this;

        _.forEach(expression, function(item) {
            if (item.kind === 'argument' && item.type === 'scripting_formField') {
                if (!item.fieldId) {
                    let originalId = item.value.toString(); 
                    let newId = item.value;
                    let has$V = false;
                    item.fieldId = originalId;
                    
                    const objName = listService.determineFieldName(originalId);
                    item.value = objName;
                }else{
                    let originalId = item.fieldId.toString();
                    const objName = listService.determineFieldName(originalId);
                    item.value = objName;
                }
            } else if (item.type === 'reporting_string' || item.type === 'reporting_date'
                        || item.type === 'reporting_number' || item.type === 'reporting_boolean' ) {
                item.kind = item.kind? item.kind : item.baseName.toLowerCase();
                item.id = listService.cleanId(item.id);
            } else if (item.type === 'reporting_datasourceField' ) {
                if (!item.fieldId) {
                    let originalId = item.value.toString();
                    let newId = item.value;
                    let has$V = false;

                    item.kind = item.kind? item.kind : item.baseName.toLowerCase();
                    const objName = listService.determineFieldName(listService.cleanId(originalId));
                    item.fieldId = originalId;
                    if (!util.isEmpty(objName)) {
                        item.value = objName;
                    } else {
                        item.value = !util.isEmpty(item.caption) ? item.caption: listService.cleanId(item.id);
                    }
                    item.id = listService.cleanId(item.id);
                }
            } else if (item.kind === 'function') {
                _.forEach(item.functionParameters, function (fp) {
                    self.fixUpFields(fp.children);
                });
            } else if (item.kind === 'grouping') {
                self.fixUpFields(item.children);
            } else if (item.type === 'scripting_special') {
                if (item.value.indexOf('workflowstage_') > -1) {
                    let id = item.value.replace('workflowstage_', '');
                    let obj = listService.getWorkflowStageByID(id);
                    item.displayValue = obj && obj.model ?
                        'Workflow - Stage "'+ obj.model.get('name')+'"' :
                        'Workflow - Stage "Unspecified"';
                } else {
                    item.displayValue = specialFormList.getTextValue(util.changeNameFields(item.value));
                }
            } else if (item.baseName === 'Operator') {
                item.kind = item.kind? item.kind : item.baseName.toLowerCase();
                item.id = listService.cleanId(item.id);
                item.value = item.value? item.value : self.fixUpOperator(item.type.toUpperCase());
            }
        });
    }

    fixUpOperator(value){
        let result = value;
        switch (value) {
            case '==': result = '=';
                break;
            case 'LT': result = '<';
                break;
            case 'GT': result = '>';
                break;
            case 'LT=': result = '<=';
                break;
            case 'GT=': result = '>=';
                break;
            case 'LTGT': result = '<>';
                break;
        }
        return result;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.model.set( propName, propVal );
    }

    updateRadioAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value; 

        let text = '[empty]';
        $('#DateValue ~ img').css( 'opacity', 0.4);
        if (propVal === 'DateValue'){
            text = '[current]';
        }

        if (propName === 'StateValue') {
             $(this.selectedItem).data('type', 'scripting_boolean');
             text = $('input[name=StateValue]:checked').next('label:first').html().trim();
             $(this.selectedItem).text(text);
             var item = this.findSelectedItemInArray();
             item.value = propVal === "StateValue" ? 'checked' : propVal;
             item.type = 'scripting_boolean';
             
             if(this.IS_CHART){
                item.type = 'reporting_boolean';
                item.dataType = 'bit';
             }

        } else {
            $('.argumentOption').prop('disabled','disabled');

            // reset values
            this.resetArgumentInputs(); 

            var selected = $('#'+propVal);
            $(selected[0]).attr('disabled', false);
            $(selected[0]).attr('readOnly', false);
            $('#'+propVal + ' .argumentOption').prop('disabled','');

            if (propVal === 'ValueOfField') {
                text = '[undefined]'
                $(this.selectedItem).text(text);

                var btn = $('#FormulaValueOfFieldButton');
                $(btn[0]).prop('disabled', false);

                var o = $('#FormulaValueOfField');
                $(o[0]).prop('readOnly', true);
                $(o[0]).prop('disabled', false);

                if (this.lastSelectedField.id !== '') {
                    $('#FormulaValueOfField').val(this.lastSelectedField.name);
                    this.updateArgument({id: this.lastSelectedField.id, value: this.lastSelectedField.name});
                }
            } else if(propVal === 'StateValue'){
                text = $('input[name=StateValue]:checked').next('label:first').html().trim();
                $(this.selectedItem).text(text);
                $(this.selectedItem).data('type', 'scripting_boolean');
                var item = this.findSelectedItemInArray();
                item.value = propVal === "StateValue" ? 'checked' : propVal;
                item.type = 'scripting_boolean';
                
                if(this.IS_CHART){
                    item.type = 'reporting_boolean';
                    item.dataType = 'bit';
                    item.value = propVal === "StateValue" ? 'Yes' : propVal;
                }
            }else if(propVal === 'TextOrNumberValue' || propVal === 'DateValue'){
                $(this.selectedItem).text(text);
                $("#DateValue ~ img").css('opacity',0.4);
                if (propVal === 'DateValue') {
                    var item = this.findSelectedItemInArray();
                    item.value = text;
                    item.type = !this.isDataSource() ? 'scripting_date' : 'reporting_date';
                    item.dataType = 'date';
                    $('#DateValue ~ img').css( 'opacity', 1.0);
                }

            }else if(propVal === 'SpecialValue'){
                text = '[undefined]'
                $(this.selectedItem).text(text);
                $('#formulaSearchBox').attr('disabled', false);
            }
        }

        $('.btn-formula-ok').button("enable");
    }

    selectFormulaItem(ev) {
        //ev.preventDefault();
        
        function enableButtons() {
            $('#btnAddLine').prop('disabled','');
            $('#btnAddFunction').prop('disabled','');
            $('#deleteFormulaItem').removeClass('hide');
            $('#formulaUp').removeClass('hide');
            $('#formulaDown').removeClass('hide');
        }

        var kind = ev.currentTarget.attributes['data-kind'].value;
        var id = '', previousKindSelected = this.selectedItem ? this.selectedItem.attributes['data-kind'].value : '';
        var parentKind;
        
        switch (kind) {
            case this.GROUPING:
            case this.FUNCTION:
                id = ev.currentTarget.parentElement.id;                
                break;
            case this.ARGUMENT:
            case this.OPERATOR:
            case this.BLANK:
                id = ev.currentTarget.id;
                break;
        } 
        
        let multiSelectionKeyPressed;
        if (ev.metaKey || ev.ctrlKey) {
            multiSelectionKeyPressed = 'ctrl';
        } else if (ev.shiftKey) {
            multiSelectionKeyPressed = 'shift';
        }

        if (multiSelectionKeyPressed){
            if (!this.multiSelectItemArray.find(item => item.id === this.selectedItem.id) && (previousKindSelected === this.ARGUMENT || previousKindSelected === this.GROUPING  || previousKindSelected === this.FUNCTION)){
                this.multiSelectItemArray.push(this.selectedItem) 
            }            
            if (!this.multiSelectItemArray.find(item => item.id === id) && (kind === this.ARGUMENT || kind === this.GROUPING || previousKindSelected === this.FUNCTION)){
                this.multiSelectItemArray.push(ev.currentTarget) 
            }
          //clear array when ctrl is not pressed  
        } else{
            this.multiSelectItemArray= [];
        }        
        
        if (this.multiSelectItemArray.length > 1){
            let botttomIndex,topIndex,bottomId,topId;
            if (this.multiSelectItemArray[0].attributes && (this.multiSelectItemArray[0].attributes['data-kind'].value === this.GROUPING || this.multiSelectItemArray[0].attributes['data-kind'].value === this.FUNCTION)){
                bottomId = this.multiSelectItemArray[0].parentElement.id;
            }else{
                bottomId = this.multiSelectItemArray[0].id;
            }

            if (this.multiSelectItemArray[this.multiSelectItemArray.length-1].attributes && (this.multiSelectItemArray[this.multiSelectItemArray.length-1].attributes['data-kind'].value === this.GROUPING || this.multiSelectItemArray[this.multiSelectItemArray.length-1].attributes['data-kind'].value === this.FUNCTION)){
                topId = this.multiSelectItemArray[this.multiSelectItemArray.length-1].parentElement.id;
            }else{
                topId = this.multiSelectItemArray[this.multiSelectItemArray.length-1].id;
            }

            let bottomItem = this.findSelectedItemInArray(bottomId);
            let parentArray = this.getItemParentArray(bottomItem);
            botttomIndex = parentArray.findIndex(item => item.id=== bottomId);
            topIndex = parentArray.findIndex(item => item.id=== topId);
            if (topIndex > botttomIndex){
                topIndex++;
                this.multiSelectItemArray = parentArray.slice(botttomIndex,topIndex);
            }else{
                botttomIndex++;
                this.multiSelectItemArray = parentArray.slice(topIndex,botttomIndex);
            }
        }
        
        
        this.selectedItem = ev.currentTarget;              

        if (this.selectedItem.parentElement) {
            const attr = this.selectedItem.parentElement.attributes['data-kind'];
            if (attr) {
                parentKind = attr.value;
            }
        }

        $('#btnAddGrouping').prop('disabled','disabled');
        $('#btnRemoveGrouping').addClass('hide');
        $('#btnAddLine').prop('disabled','disabled');
        $('#btnAddFunction').prop('disabled','disabled');
        $('#deleteFormulaItem').addClass('hide');
        $('#formulaUp').addClass('hide');
        $('#formulaDown').addClass('hide');       

        this.selectedItemId = id;

        $('.formula-item').removeClass('active');
        $('.formula-group').removeClass('active');
        $('.formula-function').removeClass('active');
       

        $('#argumentProperty').addClass('hide');
        $('#operatorProperty').addClass('hide');
        $('#functionProperty').addClass('hide');
        $('#DateValue').datepicker( "option", "disabled", true );
        $("#DateValue ~ img").css('opacity',0.4);

        if (this.multiSelectItemArray.length > 1){
            _.forEach(this.multiSelectItemArray, function (item) {
                $('#' + item.id).addClass('active');
            });

            $('#btnAddGrouping').prop('disabled', '');
            $('#btnAddGrouping').removeClass('hide');
            $('#btnRemoveGrouping').addClass('hide');
            enableButtons();

        }else{
            var item = this.findSelectedItemInArray();
            $('#' + id).addClass('active');
            // What kind of item am I?
            if (kind === this.ARGUMENT) {
                if (parentKind !== 'function') {
                    $('#btnAddGrouping').prop('disabled', '');
                    $('#btnAddGrouping').removeClass('hide');
                    $('#btnRemoveGrouping').addClass('hide');
                    enableButtons();
                }
                $('#argumentProperty').removeClass('hide');

                // Need to populate UI with properties that already exist for the selected.
                this.resetArgumentInputs();

                var value = item.value;
                var type = item.type;

                switch (type) {
                    case 'scripting_literal':
                    case 'reporting_string':
                        value = this.cleanValue(value);
                        if(this.IS_CHART){
                            this.enableTextValue(value, true);
                        }else{
                            this.enableTextValue(value, false);
                        }
                        break;
                    case 'reporting_number':
                        value = this.cleanValue(value);
                        if(this.IS_CHART){
                            this.enableNumberValue(value);
                        }else{
                            this.enableTextValue(value, false);
                        }
                        break;
                    case 'scripting_literal_text':
                        value = this.cleanValue(value);
                        this.enableTextValue(value, true);
                        break;
                    case 'scripting_literal_num':
                        value = this.cleanValue(value);
                        this.enableNumberValue(value);
                        break;
                    case 'scripting_date':
                    case 'reporting_date':
                        this.enableDateValue(value);
                        break;
                    case 'scripting_boolean':
                    case 'reporting_boolean':
                        $('#StateValue .argumentOption').attr('disabled', false);  
                        $('input[value="' +  (util.isTrue(value) || value === 'checked' ? 'checked' : 'notchecked') + '"]').prop('checked', true);
                        $('input[value=StateValue]').prop('checked','checked');
                        if (type === 'reporting_boolean'){
                            if (util.isTrue(value) || value === 'checked'){
                                $('#StateValue_Yes').prop('checked','checked');
                            }else{
                                $('#StateValue_No').prop('checked','checked');
                            }
                        }
                        break; 
                    case 'scripting_formField':
                    case 'reporting_datasourceField':
                        if (this.IS_CHART){
                            this.enableSpecialValue(item.fieldId, false);
                        }else{
                            this.enableSpecialValue(value, true);
                            this.lastSelectedField = {id: item.fieldId, name: value};
                        }                        
                        break;
                    case 'scripting_special':
                        this.enableSpecialValue(value, false);
                        break;
                }

            }

            if (kind === this.OPERATOR) {

                $('#btnAddGrouping').prop('disabled','disabled');
                $('#btnAddGrouping').removeClass('hide');
                $('#btnRemoveGrouping').addClass('hide');
                enableButtons();

                $('#operatorProperty').removeClass('hide');

                $('#operatorList').find('option[value="'+item.value+'"]').prop('selected', true);

            }
        
            if (kind === this.GROUPING) {
                $('#btnAddGrouping').prop('disabled','disabled');
                $('#btnAddGrouping').addClass('hide');
                $('#btnRemoveGrouping').removeClass('hide');
                enableButtons();
            }

            if (kind === this.FUNCTION) {
                $('#btnAddGrouping').prop('disabled','');
                $('#btnAddGrouping').removeClass('hide');
                $('#btnRemoveGrouping').addClass('hide');

                $('#functionProperty').removeClass('hide');
                enableButtons();
            }

           if (kind === this.BLANK) {
                $('#btnAddLine').prop('disabled','');
                $('#btnAddFunction').prop('disabled','');
                $('#btnAddGrouping').prop('disabled', 'disabled');
            }

            if(this.isDataSource() && item.paramType){
                this.validateParameterType(item.paramType);
            }
        }        
    }

    enableSpecialValue(value, isField = false){
        if(isField){
            $('#FormulaValueOfField').val(value);
            $('#FormulaValueOfField').attr('disabled', false);
            $('#FormulaValueOfFieldButton').attr('disabled', false);
            $('input[value=ValueOfField]').prop('checked','checked');
        }else{
            $('#SpecialValue').attr('disabled', false);
            $('#formulaSearchBox').attr('disabled', false);
            $('#SpecialValue').find('option[value="'+value+'"]').prop('selected', true);
            $('input[value=SpecialValue]').prop('checked','checked');
        }
    }

    cleanValue(value){
        let _value = value;
        if (_value === '[empty]') {
            _value = ''
        }
        
        return _value;
    }

    enableTextValue(value, justTextValue = false){
        if(justTextValue){
            $('#TextValue').val(value);
            $('input[value=TextValue]').prop('checked','checked');
            $('#TextValue').attr('disabled', false);
        }else{
            $('#TextOrNumberValue').val(value);
            $('input[value=TextOrNumberValue]').prop('checked','checked');
            $('#TextOrNumberValue').attr('disabled', false);
        }
    }

    enableNumberValue(value){
        $('#NumberValue').val(value);
        $('input[value=NumberValue]').prop('checked','checked');
        $('#NumberValue').attr('disabled', false);
    }

    enableDateValue(value){
        let val = value;
        $('#DateValue').attr('disabled', false);
        $('#DateValue').datepicker("option", "disabled", false);
        $("#DateValue ~ img").css('opacity', 1.0);
        if (this.IS_CHART) {
            val = Moment(value).format('D MMMM YYYY');
            $('#DateValue').datepicker({ dateFormat: 'd MM yy' });
        }
        $('#DateValue').datepicker("setDate", val);
        $('input[value=DateValue]').prop('checked', 'checked');
    }

    resetArgumentInputs() {
        $('#TextOrNumberValue').val('');
        $('#TextOrNumberValue').prop('disabled','disabled');
        
        $('#TextValue').val('');
        $('#TextValue').prop('disabled','disabled');
        $('#NumberValue').val('');
        $('#NumberValue').prop('disabled','disabled');

        $('#DateValue').val('');
        $('#DateValue').prop('disabled','disabled');
        $("#DateValue ~ img").css('opacity',0.4);
        $('#FormulaValueOfField').val('');
        $('#FormulaValueOfField').prop('disabled','disabled');
        $('#FormulaValueOfFieldButton').attr('disabled', true);

        $('#SpecialValue option').prop('selected', false);
        $('#SpecialValue').attr('disabled', true);

        $('#StateValue_Yes').prop('checked', 'checked');
        $('#StateValue_No').prop('checked', '');
    }

    addLine(selectedItem, selectedIndex) {

        var type = "scripting_literal";
        if(this.model.get('type') && this.model.get('type') === 'DataSource'){
            type = "scripting_literal_text";
        }
        var value = this.EMPTY;
        var id = sequenceService.nextDomId();

        const newItem = this.addItem({
            id: id,
            kind: this.ARGUMENT,
            type: type,
            value: value
        },selectedItem, selectedIndex);

        this.selectedItemId = id;
        $('#' + this.selectedItemId + '.formula-item').first().trigger('click');

        return newItem;
    }

    addOperator(selectedItem, selectedIndex) {
        var type = "+";
        var value = "+";
        var id = sequenceService.nextDomId();

        const newItem = this.addItem({
            id: id,
            kind: this.OPERATOR,
            type: type,
            value: value
        },selectedItem, selectedIndex);

        this.selectedItemId = id;

        return newItem;

    }

    addItem(item, selectedItem, selectedIndex) {
        let rootEl = this.FORMULA_LIST;
        // find ROOT object of currently selected item (i.e. FORMULA_LIST, GROUP )
        /*
        let selectedItem = this.findSelectedItemInArray();

        // Then locate the index of the selected item with that Array.
        let selectedIndex = this.findSelectedIndexInParent(selectedItem);

        if ((selectedItem.kind !== this.OPERATOR) && selectedIndex > 0) {
            //selectedIndex--;
        }
        */

        item.parent = selectedItem.parent;
        if (selectedItem.parent !== this.FORMULA_LIST) {
            rootEl = '#' + selectedItem.parent + ' div.formulaGroupItem';
            // splice the new Item after that item.
            //selectedIndex = selectedItem.parent.children.length; // Insert at bottom for now. Remove if we decide to insert after selected and get the DOM doing the Same Below.
            //selectedItem = selectedItem.parent.children[selectedIndex];

            const parentArray = this.getItemParentArray(selectedItem);
            parentArray.splice(selectedIndex, 0, item);
        } else {
            // splice the new Item after that item.
            //selectedIndex = this.formulaExpression.length; // Insert at bottom for now. Remove if we decide to insert after selected and get the DOM doing the Same Below.
            //selectedItem = this.formulaExpression[selectedIndex];
            this.formulaExpression.splice(selectedIndex, 0, item);
        }

        // Use Root object here to append correctly.
        if (item.kind === this.FUNCTION) {
            //$(rootEl).first().append(functionTemplate(item));
            if (selectedItem.kind === 'operator') {
                let parentArrays = this.getItemParentArray(selectedItem);
                $(functionTemplate(item)).insertAfter( $('#' + parentArrays[selectedIndex-1].id) );
            }else{
             $(functionTemplate(item)).insertAfter( $('#' + selectedItem.id) );
            }
        } else {
            //$(rootEl).first().append('<div id="' + item.id + '" class="formula-item" data-kind="' + item.kind + '" data-type="' + item.type + '">' + item.value + '</div>')
            let value = item.value;
            if (value === '') { value = this.EMPTY; }
            if ((!$.isNumeric(value)) && (value !== this.EMPTY) && (item.kind !== this.OPERATOR)) {
                value = '"' + value + '"';
            }
            

            if (selectedItem.kind === 'blank') {
                $('<div id="' + item.id + '" class="formula-item" data-kind="' + item.kind + '" data-type="' + item.type + '">' + value + '</div>').insertBefore($('#' + selectedItem.id));
            } else {
                if (selectedItem.kind === 'operator') {  
                    let parentArrays = this.getItemParentArray(selectedItem);          
                    $('<div id="' + item.id + '" class="formula-item noselect" data-kind="' + item.kind + '" data-type="' + item.type + '" style="white-space: pre" >' + value + '</div>').insertAfter($('#' + parentArrays[selectedIndex-1].id));
                } else{
                   $('<div id="' + item.id + '" class="formula-item noselect" data-kind="' + item.kind + '" data-type="' + item.type + '" style="white-space: pre" >' + value + '</div>').insertAfter($('#' + selectedItem.id));
                }
            } 

            // May need to look at this a little closer if we need to insert After the selected Item vs at the bottom of the group
            /*
            let newEl = document.createElement('div');
            newEl.innerHTML = item.value;
            newEl.id = item.id;
            newEl.classList = 'formula-item';
            newEl["data-kind"] = item.kind;
            newEl["data-type"] = item.type;

            this.insertAfter(newEl, $(rootEl).first());
            */
        }

        this.hookEvents();

        $('.btn-formula-ok').button("enable");

        return {selectedIndex: selectedIndex, selectedItem: item};
    }

    addGrouping() {
        // find selected item
        var item = this.findSelectedItemInArray();

        // Create new Grouping Item with the current item as a child.
        // insert new Grouping Item in the Array at the same position as the previously removed item.
        var id = sequenceService.nextDomId();
        var groupingItem = {
            id: id,
            kind: this.GROUPING,
            type: 'grouping',
            value: '',
            children: [item]
        };

        let arrayLenght = this.multiSelectItemArray.length;
        if (arrayLenght > 1){
            groupingItem.children = this.multiSelectItemArray;
            this.replaceItem(this.multiSelectItemArray[0], groupingItem);
            //remove from DOM  deleteItemFromGouping
            for (var i = 1; i < arrayLenght; i++) {                
                $('#' + this.multiSelectItemArray[i].id).remove();
            }
            //remove from array
            for (var i = 1; i < arrayLenght; i++) {
                this.deleteItemFromGouping(this.multiSelectItemArray[i]);
            }
             //assign new parentId
            _.forEach(groupingItem.children, function (item) {
                item.parent = groupingItem.id;
            })
            
            $('#' + this.multiSelectItemArray[0].id).replaceWith(groupTemplate(groupingItem));
        }else{
            this.replaceItem(item, groupingItem);
            //this.addGroupingItem(groupingItem, itemIndex);

            // DOM Stuff
            // Remove old Element and Insert New Grouping Element
            $('#' + this.selectedItemId).replaceWith(groupTemplate(groupingItem));
        }
        $(this.FORMULA_LIST).empty();
        this.renderList();
        //this.renderGroupings('#' + groupingItem.id, groupingItem);

        var newEl = $('#' + id);
        this.selectFormulaItem({
            currentTarget: newEl[0].children[0]
        });


        this.hookEvents();

        $('.btn-formula-ok').button("enable");
    }

    removeGrouping() {
        // find selected item
        var item = this.findSelectedItemInArray();

        // extract the child item
        var child = item.children[0];
        child.parent = item.parent;

        // Replace originally selected item with the child that was extracted.
        this.replaceItem(item, child);

        // DOM Stuff
        var childElement = $('#' + child.id);
        if (item.children.length > 1){            
            //add items in the array in the right parent position
            let parentArray = this.getItemParentArray(item);
            let index = this.findIndexInParent(child);
            for (var i = 1; i < item.children.length; i++) {
                item.children[i].parent = item.parent;
                parentArray.splice(i+index,0,item.children[i])
            } 
            $(this.FORMULA_LIST).empty();
            this.renderList();
        } else{
            $('#' + this.selectedItemId).replaceWith(childElement);
        }       
       
        var newEl = $('#' + child.id);

        if (newEl[0].classList.contains('formula-group')) {
            newEl = newEl[0].children;
        }
        this.selectFormulaItem({
            currentTarget: newEl[0]
        });

        $('.btn-formula-ok').button("enable");
    }

    replaceItem(item, newItem) {
        // lookup the item in the array, replace with the child in the same position.
        var replaced = false;

        for (var i = 0; i < this.formulaExpression.length; i++) {
            if (this.formulaExpression[i].id === item.id) {
                this.formulaExpression[i] = newItem;
                replaced = true;
            }

            if (this.formulaExpression[i].children && (!replaced)) {
                replaced = this.replaceSubItem(this.formulaExpression[i].children, item, newItem);
            }

            if (replaced) { break; }
        }

    }

    replaceSubItem(subItems, item, newItem) {
        var replaced = false;

        for (var i = 0; i < subItems.length; i++) {
            if (subItems[i].id === item.id) {
                subItems[i] = newItem;
                replaced = true;
            }

            if (subItems[i].children && (!replaced)) {
                replaced = this.replaceSubItem(subItems[i].children, item, newItem);
            }

            if (replaced) { break; }
        }

        return replaced;
    }

    insertAfter(newElement,targetElement) {
        //target is what you want it to go after. Look for this elements parent.
        var parent = targetElement[0].parentNode;

        //if the parents lastchild is the targetElement...
        if(parent.lastchild === targetElement) {
            //add the newElement after the target element.
            parent.appendChild(newElement);
        } else {
            // else the target has siblings, insert the new element between the target and it's next sibling.
            parent.insertBefore(newElement, targetElement[0].nextSibling);
        }
    }

    addFunction(selectedItem, selectedIndex) {
        var functionParameters = this.buildFunctionParameters('script_abs');

        var id_function = sequenceService.nextDomId();
        var functionItem = {
            id: id_function,
            kind: this.FUNCTION,
            type: 'script_abs',
            value: '',
            functionName: 'Absolute',
            functionParameters: functionParameters
        };

        //this.formulaExpression.push(functionItem);
        const newItem = this.addItem(functionItem, selectedItem, selectedIndex);
        this.selectedItemId = id_function;
        $('#' + this.selectedItemId + ' div.formula-item').first().trigger('click');

        return newItem;
    }

    deleteItem() {
        if(this.multiSelectItemArray.length > 1){
            this.deleteItems();
            return;
        }
        let deleteCount = 2;
        let selectedItem = this.findSelectedItemInArray();
        let selectedIndex = this.findSelectedIndexInParent(selectedItem);
        //const parentArray = selectedItem.parent === this.FORMULA_LIST ? this.formulaExpression : selectedItem.parent.children;
        const parentArray = this.getItemParentArray(selectedItem);

        if (selectedItem.kind !== this.OPERATOR) {
            selectedIndex--;
            if (selectedIndex < 0) {
                selectedIndex = 0;
                if (parentArray.length === 1 || (parentArray.length === 2 && parentArray[1].kind === this.BLANK)) {
                    deleteCount = 1;
                }
            }
        }

        selectedItem = parentArray[selectedIndex];

        var idsToDelete = [selectedItem.id];
        if (deleteCount > 1) {
            idsToDelete.push(parentArray[selectedIndex+1].id);
        }


        // Remove from array
        parentArray.splice(selectedIndex, deleteCount);



        // Remove from DOM
        _.forEach(idsToDelete, function (id) {
            $('#' + id).remove();
        })

        this.selectedItem = undefined;
        this.selectedItemId = '';
        $('#argumentProperty').addClass('hide');
        $('#operatorProperty').addClass('hide');
        $('#functionProperty').addClass('hide');

        $('.btn-formula-ok').button("enable");

    }

    deleteItems() {
        let self = this;
        _.forEach(this.multiSelectItemArray, function (item) {
            let deleteCount = 2;
            let selectedItem = item;
            let selectedIndex = self.findIndexInParent(selectedItem);            
            const parentArray = self.getItemParentArray(selectedItem);

            if (selectedItem.kind !== self.OPERATOR) {
                selectedIndex--;
                if (selectedIndex < 0) {
                    selectedIndex = 0;
                    if (parentArray.length === 1 || (parentArray.length === 2 && parentArray[1].kind === self.BLANK)) {
                        deleteCount = 1;
                    }
                }
            }else{
                return;
            }

            selectedItem = parentArray[selectedIndex];

            var idsToDelete = [selectedItem.id];
            if (deleteCount > 1) {
                idsToDelete.push(parentArray[selectedIndex+1].id);
            }


            // Remove from array
            parentArray.splice(selectedIndex, deleteCount);



            // Remove from DOM
            _.forEach(idsToDelete, function (id) {
                $('#' + id).remove();
            });
        });

        this.selectedItem = undefined;
        this.selectedItemId = '';
        $('#argumentProperty').addClass('hide');
        $('#operatorProperty').addClass('hide');
        $('#functionProperty').addClass('hide');

        $('.btn-formula-ok').button("enable");

    }

    deleteItemFromGouping(item) {
        let selectedIndex = this.findIndexInParent(item);        
        const parentArray = this.getItemParentArray(item);         

        // Remove from array
        parentArray.splice(selectedIndex, 1);
       let x= this,formulaExpression;
    }

    updateArgument(ev) {
        // Kind = argument
        // Type = (scripting_literal, scripting_date, scripting_boolean, scripting_special, scripting_formField)

        var kind = "argument";

        var inputName = $('input[name=ValueOption]:checked').val();
        var value = '';
        var targetEl = '';
        var type = '';
        var id = '';
        let dataType = '';


        if (inputName === 'StateValue') {
            type = ev.currentTarget.attributes['data-type'].value;
        } else if (inputName === 'ValueOfField') {
            type = 'scripting_formField';
        } else {
            targetEl = $('#' + inputName);
            type = targetEl[0].attributes['data-type'].value;
        }


        let displayValue = ev.value;
        switch (type) {
            case 'scripting_literal':
            case 'scripting_literal_text':
            case 'scripting_literal_num':
            case 'reporting_string':
            case 'reporting_number':
                value = $('#' + inputName).val();
                if (value === '') {value = this.EMPTY}

                displayValue = value;
                if (!$.isNumeric(value) && (value !== this.EMPTY)) {
                    displayValue = '"' + value + '"';
                }
                break;
            case 'scripting_date':
            case 'reporting_date':
                if(this.IS_CHART){
                        value = Moment($('#' + inputName).datepicker( "getDate" )).format('YYYY-MM-DD HH:mm:ss');
                        displayValue = $('#' + inputName).datepicker({dateFormat: 'd MM yy'}).val();
                }else{
                    value = $('#' + inputName).datepicker({dateFormat: 'd MM yy'}).val();
                    displayValue = value; 
                }
                break;
            case 'scripting_boolean':
            case 'reporting_boolean':
                value = ev.currentTarget.attributes['value'].value;
                displayValue = value;
                break;
            case 'scripting_formField':
            case 'reporting_datasourceField':
                value = ev.value;
                id = ev.id;
                displayValue = value;
                break;
            case 'scripting_special':
                value = $('#' + inputName).val();
                displayValue = $('#' + inputName + " option:selected").text();
                break;
        }

        if(this.IS_CHART){
                switch (type) {    
                    case 'scripting_literal_text':
                       type = 'reporting_string';
                       dataType = 'string';
                       break;
                    case 'scripting_literal_num':
                       type = 'reporting_number';
                       dataType = 'int';
                       break;
                    case 'scripting_date':
                       type = 'reporting_date';
                       dataType = 'date';
                       break;
                    case 'scripting_special':
                       type = 'reporting_datasourceField';
                       dataType = this.getDataType(displayValue, inputName);
                       break;
                }
        } 

        // Find el in DOM and update (value and type)
        $(this.selectedItem).data('type', type);
        $(this.selectedItem).text(displayValue);

        // Find el in Collection and Update (Value and type)
        var item = this.findSelectedItemInArray();
        item.value = value;
        item.type = type;
        item.fieldId = id; 
        
        if(this.IS_CHART) {

            item.dataType = dataType;
            if (type === 'reporting_datasourceField') {
                item.caption = displayValue;

                if (this.model.get('dataSource')) {
                    let itemFound = _.find(this.model.get('dataSource').Field, { name: value });
                    if (itemFound) {
                        item.value = displayValue;
                        item.fieldId = itemFound.id;
                    }
                }
            }
        }        

        $('.btn-formula-ok').button("enable");
    }

    getDataType(caption){
        let dataType;
        switch(caption){
            case 'Meta - Last Submission Date':
                dataType = 'SMALLDATETIME'
                break;
            case 'Meta - Instance Number':
            case 'Meta - Version Major':
            case 'Meta - Version Minor':
                dataType = 'INT';
                break;
            default:
                dataType = 'NVARCHAR(400)';
                break;
        }
        return dataType;
    }

    updateOperator(ev) {

        var value = $('#operatorList').val();
        var type = $('#operatorList').find(':selected')[0].attributes['data-type'].value;

        $(this.selectedItem).attr('data-type', type);
        $(this.selectedItem).text(value);

        var item = this.findSelectedItemInArray();
        item.value = value;
        item.type = type;

        $('.btn-formula-ok').button("enable");
    }

    updateFunction(ev) {
        var value = $('#functionList').val();
        var type = $('#functionList').find(':selected')[0].attributes['data-type'].value;

        var functionParameters = this.buildFunctionParameters(type);
        var item = this.findSelectedItemInArray();
        item.functionName = value;
        item.type = type;
        item.functionParameters = functionParameters;

        $('#' + this.selectedItemId).replaceWith(functionTemplate(item));

        this.hookEvents();
        $('.btn-formula-ok').button("enable");
    }

    buildFunctionParameters(type) {
        var functionParameters = [];
        var self = this;

        var parameters = formulaService.getFunctionParameters(type, this.isDataSource());

        // loop through Parms, build a FunctionParameter object for each, add a default argument item as a child to each.
        _.each(parameters, function(param) {
            var id = sequenceService.nextDomId();
            functionParameters.push({
                name: param,
                children: [{
                    id: id,
                    kind: self.ARGUMENT,
                    type: 'scripting_literal',
                    value: '',
                    paramType: param
                }]
            });
        });

        return functionParameters;

    }

    getItemParentArray(selectedItem) {
        let array = [];

        if (!selectedItem.parent || selectedItem.parent === this.FORMULA_LIST) {
            array = this.formulaExpression;
        } else {
            array = this.findSelectedItemInArray( selectedItem.parent ).children;
        }

        return array;

    }

    movePosition(direction, itemId) {

        var moveValue = 2;        
        if (direction === 'up') { moveValue = -2; }

        //move in array
        // Items (Arguments/Functions/Grouping) are tied to the Operator preceding it. They must be moved too.
        /*
        var selectedIndex = this.formulaExpression.findIndex(this._getCurrentSelectedItem.bind(this));
        var selectedItem = this.formulaExpression[selectedIndex];
        if (selectedItem.kind === this.OPERATOR) {
            selectedIndex++;
            selectedItem = this.formulaExpression[selectedIndex];
        }
        */
        let selectedItem, selectedIndex;
        if (itemId){
            selectedItem = this.findSelectedItemInArray(itemId);
            selectedIndex = this.findIndexInParent(selectedItem);            
        }else{
            selectedItem = this.findSelectedItemInArray();
            selectedIndex = this.findSelectedIndexInParent(selectedItem);           
        }        

        //const parentArray = selectedItem.parent === this.FORMULA_LIST ? this.formulaExpression : selectedItem.parent.children;
        const parentArray = this.getItemParentArray(selectedItem);

        var newIndex = selectedIndex + moveValue;
        if (newIndex > -1 & newIndex < parentArray.length) {
            var selectedOperator = parentArray[selectedIndex -1];
            var targetOperator = parentArray[newIndex -1];
            var targetItem = parentArray[newIndex];

            if ((targetOperator && targetOperator.kind === 'blank') || (targetItem && targetItem.kind === 'blank')){
                return;
            }

            if (direction === 'up') {

                if (newIndex > 0) {
                    parentArray.splice(newIndex-1, 4);
                    parentArray.splice(newIndex - 1, 0, selectedOperator, selectedItem, targetOperator, targetItem);
                } else {
                    var id = sequenceService.nextDomId();
                    targetOperator = {
                        id: id,
                        kind: this.OPERATOR,
                        type: "+",
                        value: "+"
                    }

                    parentArray.splice(newIndex, 3);
                    parentArray.splice(0, 0, selectedItem, targetOperator, targetItem);
                }

            } else {


                if (selectedIndex === 0) {
                    var id = sequenceService.nextDomId();
                    selectedOperator = {
                        id: id,
                        kind: this.OPERATOR,
                        type: "+",
                        value: "+"
                    }

                    parentArray.splice(selectedIndex, 3);
                    parentArray.splice(selectedIndex, 0, targetItem, selectedOperator, selectedItem );

                } else {
                    parentArray.splice(selectedIndex-1, 4);
                    parentArray.splice(selectedIndex-1, 0, targetOperator, targetItem, selectedOperator, selectedItem );
                }



            }

            // Move in DOM
            var op1El = '';
            if (selectedIndex === 0) {
                op1El = ['<div id="' + selectedOperator.id + '" class="formula-item" data-kind="' + selectedOperator.kind + '" data-type="' + selectedOperator.type + '">' + selectedOperator.value + '</div>'];

            } else {
                op1El = $('#' + selectedOperator.id).clone();
            }
            var seletedEl = $('#' + selectedItem.id).clone();
            var op2El = '';
            if (newIndex > 0) {
                op2El = $('#' + targetOperator.id).clone();
            } else {
                op2El = ['<div id="' + targetOperator.id + '" class="formula-item" data-kind="' + targetOperator.kind + '" data-type="' + targetOperator.type + '">' + targetOperator.value + '</div>'];
            }
            var targetEl = $('#' + targetItem.id).clone();

            $('#' + selectedOperator.id).attr('id', 'temp_' + selectedOperator.id);
            $('#' + selectedItem.id).attr('id', 'temp_' + selectedItem.id);

            if (newIndex > 0) {
                $('#' + targetOperator.id).replaceWith(op1El[0]);
            }
            $('#' + targetItem.id).replaceWith(seletedEl);
            $('#' + 'temp_' + selectedOperator.id).replaceWith(op2El[0]);
            $('#' + 'temp_' + selectedItem.id).replaceWith(targetEl[0]);

            //$('#temp_' + selectedOperator.id).attr('id', selectedOperator.id);
            //$('#temp_' + this.selectedItemId).attr('id', this.selectedItemId);

            this.hookEvents();

            $('.btn-formula-ok').button("enable");

        }

    }

    _getCurrentSelectedItem(item) {
       return item.id === this.selectedItemId;
    }

    findSelectedItemInArray(id) {
        var self = this;
        var found = undefined;
        var root = undefined;
        var findId = id ? id : this.selectedItemId;

        //for (var i = 0; i < this.formulaExpression.length; i++) {
        _.every(this.formulaExpression, function(item) {
            found = self.findSelectedItem(item, findId);

            root = item;
            //found = self.findSelectedItem(this.formulaExpression[i]);
            //root = this.formulaExpression[i];
            return (!found);
            //if (found) {
             //   break;
           // }
        });

        //return { found: found, root: root }
        found.parent = found.parent ? found.parent : this.FORMULA_LIST;
        return found;

    }

    findSelectedItem(item, findId) {
        var found = undefined;
        var self = this;

        if (item.id === findId) {
            found = item;
            found.parent = undefined;
        }
        if (!found) {
            if (item.kind === this.FUNCTION) {
                _.every(item.functionParameters, function (parm) {
                    if (parm.children[0].id === findId) {
                        found = parm.children[0];
                    }
                    return (!found);
                });

            } else if (item.children) {
                _.every(item.children, function(child) {
                    found = self.findSelectedItem(child, findId);
                    if (found && (!found.parent)) {
                        found.parent = item.id;
                    }
                    return (!found);
                });

            }
        }

        return found;


    }

    findSelectedIndexInParent(item) {
        let selectedIndex;

        if (item.parent !== this.FORMULA_LIST) {
            const parentArray = this.getItemParentArray(item);
            selectedIndex = parentArray.findIndex(this._getCurrentSelectedItem.bind(this));
        } else {
            selectedIndex = this.formulaExpression.findIndex(this._getCurrentSelectedItem.bind(this));
        }
        return selectedIndex;
    }

    findIndexInParent(itemSelected) {
        let index;
        //this.formulaExpression.findIndex(item => item.id=== itemSelected.id);
        if (itemSelected.parent !== this.FORMULA_LIST) {
            const parentArray = this.getItemParentArray(itemSelected);
            index = parentArray.findIndex(item => item.id=== itemSelected.id);
        } else {
            index = this.formulaExpression.findIndex(item => item.id=== itemSelected.id);
        }
        return index;
    }

    showValueFieldModal(ev) {
        ev.preventDefault();

        var sfModel = new Model();
        var formulaSelectedItem = $(".formula-item.noselect.active");
        var formulaSelectedItemId = undefined;
        var previousFormulaValue = undefined;
        if(formulaSelectedItem && formulaSelectedItem.length && formulaSelectedItem.length > 0)
        {
            formulaSelectedItemId = $(".formula-item.noselect.active")[0].id;
        }
        if(formulaSelectedItemId && this.model.attributes.formulaParameter 
            && this.model.attributes.formulaParameter.arguments)
        {
            previousFormulaValue = this.model.attributes.formulaParameter.arguments
            .filter(x=> x.id == formulaSelectedItemId);
        }
        
        if(previousFormulaValue && previousFormulaValue.length && previousFormulaValue.length > 0)
        {
            if(previousFormulaValue[0].fieldId)
            {
                sfModel.set("dataSelectedItemId", previousFormulaValue[0].fieldId, {silent:true});
            }
            else
            {
                sfModel.set("dataSelectedItemId", previousFormulaValue[0].Id, {silent:true});
            }
        }
        else
        {
            if(this.lastSelectedField
            && this.lastSelectedField.id)
            {
                sfModel.set("dataSelectedItemId", this.lastSelectedField.id, {silent:true});
            }
            else
            {
                sfModel.set("dataSelectedItemId", "", {silent:true});
            }
        }
        
        var sfModal = new selectFieldModal({model: sfModel});
        sfModal.render().then((selectedField)=>{

            $('#FormulaValueOfField').val(selectedField.name);
            this.lastSelectedField = {id: selectedField.id, name: selectedField.name};
            this.updateArgument({id: selectedField.id, value: selectedField.name});

        });
    }

    hookEvents() {
        var self = this;

        $('.formula-item').off('click');

        $('.formula-item').on('click', function (e) {
            self.selectFormulaItem(e);
        });

        $('.formula-group-item').off('click');
        $('.formula-group-item').on('click', function (e) {
            self.selectFormulaItem(e);
        });
        const delayFilterFn = _.debounce((event)=>{
            const items = this.model.get('specialInstance').filter(item=>{
                return RegExp(event.target.value, 'i').test(item.text) || RegExp(event.target.value, 'i').test(item.translated);
            });
            $('#SpecialValue').empty();
            if (items.length === 0) {
                $('#SpecialValue').append(`<option disabled class="no-results">${constants.EMPTY_SEARCH}</option>`);
            } else {
                items.forEach(item=>{
                    $('#SpecialValue').append(`<option value=${item.value}>${util.changeNameFields(item.text)}</option>`);
                });
            }
        }, 350);

        $('#formulaSearchBox').on('keyup', function (e) {
            delayFilterFn(e);
        });

        this.eventsHooked = true;
    }

    closeModal() {
        $('#formulaModal').remove();
    }

    buildFormulaExpression() {
        let typeParameter = 'scriptingParameter';
        if(this.model.get('formulaType') && (this.model.get('formulaType') === 'groupFormula' || 
                                             this.model.get('formulaType') === 'valueFormula' ||
                                             this.model.get('formulaType') === 'sideFormula' ||
                                             this.model.get('formulaType') === 'typeFormula')){
           typeParameter = 'reportingColumn';
        }
        else if (this.model.get('type') && this.model.get('type') === 'DataSource'){
            typeParameter = 'reportingFilter';
        } else if (typeof this.model.get('expressionType') !== 'undefined'){
            typeParameter = this.model.get('expressionType');
        }
        
        let expression = {
            id: sequenceService.nextDomId(),
            type: typeParameter
        };

        this.formulaExpression.splice(this.formulaExpression.length-1, 1);
        expression.arguments = this.formulaExpression;
        if(!this.model.get('formulaType') || this.model.get('formulaType') === 'formulaParameter'){
           this.model.set('formulaParameter', expression, {silent: true});
        }else if(this.model.get('formulaType') === 'groupFormula'){
            this.model.set('groupFormula', expression, {silent: true});
        }else if(this.model.get('formulaType') === 'valueFormula'){
            this.model.set('valueFormula', expression, {silent: true});
        }else if(this.model.get('formulaType') === 'sideFormula'){
            this.model.set('sideFormula', expression, {silent: true});
        }else if(this.model.get('formulaType') === 'typeFormula'){
            this.model.set('typeFormula', expression, {silent: true});
        }
    } 

    renderItem(parent, item) {
        if (item.kind === this.ARGUMENT || item.kind === this.OPERATOR || item.kind === this.BLANK) {
            $('#' + item.id).remove();
 
            let value = '';
            if(!item.value){
              value = item.value =  namesUtil.determineFieldName(item.fieldId);
            }else{
              value = item.value;
            }
            if (value === '') { value = this.EMPTY; }

            if (item.kind === this.ARGUMENT && value !== this.EMPTY) {
                if(value === 'true' || value === 'false'){
                    value = this.returnBooleanText(value, item.type);
                }else if (!$.isNumeric(value) && item.type !== "reporting_date") {
                    value = '"' + value + '"';
                }
            }
            
            if (item.type === 'scripting_literal') {
                value = util.sanitizeHTML(value, true, '');
            }

            if (item.type === 'scripting_special') {
                if (!item.displayValue){
                    if (item.value.indexOf('workflowstage_') > -1) {
                        let id = item.value.replace('workflowstage_', '');
                        let obj = listService.getWorkflowStageByID(id);
                        item.displayValue = obj && obj.model ?
                            'Workflow - Stage "'+ obj.model.get('name')+'"' :
                            'Workflow - Stage "Unspecified"';
                    } else {
                        item.displayValue = specialFormList.getTextValue(util.changeNameFields(item.value));
                    }
                }
                value = item.displayValue;
            }

            if(value !== "[current]" && this.IS_CHART && item.type === 'reporting_date' || item.type === 'scripting_date'){
                    value = Moment(this.cleanValue(value)).format('D MMMM YYYY');        
            }

            $(parent).first().append('<div id="' + item.id + '" class="formula-item noselect" data-kind="' + item.kind + '" data-type="' + item.type + '" style="white-space: pre" >' + value + '</div>')
        }

        if (item.kind === this.FUNCTION) {
            //templates not handle undefined
            if (!item.functionParameters){
                item.functionParameters = null;
            }
            $('#' + item.id).remove();
            $(parent).first().append(functionTemplate(item));
        }
    }

    returnBooleanText(value, type){
         let text = 'Checked (yes)';
         let isTrue = util.isTrue(value);
         switch (this.model.get('type')){
            case 'DataSource': 
                text = isTrue ? 'Yes' : 'No';
                break;
            case 'Formula':
                if (type === 'scripting_boolean') {
                    text = isTrue ? 'Checked (yes)' : 'Unchecked (no)';
                } else {
                    text = isTrue ? 'true' : 'false';
                }
                break;
            default: text = isTrue ? 'Checked (yes)' : 'Unchecked (no)';
               break;
         }

         return  text;
    }

    renderList() {
       var self = this;

        _.each(this.formulaExpression, function (item) {
            if (item.kind === self.GROUPING) {
                $(self.FORMULA_LIST).append(groupTemplate({id: item.id , kind: item.kind, type: item.type, children: []})); // No children on the first run
                self.renderGroupings('#' + item.id, item);
            } else {
                self.renderItem(self.FORMULA_LIST, item);
            }
        });

        this.hookEvents();
    }

    renderGroupings(parent, item) {
        const self = this;

        _.forEach(item.children, function (child) {
            if (child.kind === self.GROUPING) {
                //$('#' + item.id + ' div.formulaGroupItem').empty();
                if ($(parent + ' div.formulaGroupItem'+parent.slice(1)).length === 1){
                    $(parent + ' div.formulaGroupItem'+parent.slice(1)).append(groupTemplate(child));
                }else{
                    $(parent + ' div.formulaGroupItem'+child.id).append(groupTemplate(child));
                }
                
                // should only do this is child.children[x] have children.
                _.forEach(child.children, function(grandchild) {
                    if (grandchild.kind === self.GROUPING) {
                        self.renderGroupings('#' + grandchild.id, grandchild);
                    }                    
                });

            } else {
                self.renderItem(parent +  ' div.formulaGroupItem'+parent.slice(1), child);
            }
        });

    }

    render() {
        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));
            $('body').append(this.$el);
            listService.isUndoRedoEnabled = false;

            var self = this;

            // Show modal popup window
            this.dialog = $('#formulaModal').dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: 540,
                width: 688,
                minWidth: 688,
                minHeight: 540,
                modal: true,
                resizable: true,
                buttons: [
                    {
                        text: 'OK',
                        'class':'btn-formula-ok btn-std-size btn-default hvr-glow normal-font',
                        'disabled': true,
                        click: () => {
                            this.buildFormulaExpression();
                            this.dialog.dialog( "close" );
                            if(!this.model.get('formulaType') || this.model.get('formulaType') === 'formulaParameter'){
                               resolve(this.model.get('formulaParameter'));
                            }else if(this.model.get('formulaType') === 'groupFormula'){
                               resolve(this.model.get('groupFormula'));
                            }else if(this.model.get('formulaType') === 'valueFormula'){
                               resolve(this.model.get('valueFormula'));
                            }else if(this.model.get('formulaType') === 'sideFormula'){
                                resolve(this.model.get('sideFormula'));
                            }else if(this.model.get('formulaType') === 'typeFormula'){
                                resolve(this.model.get('typeFormula'));
                            }
                            
                        }
                    },
                    {
                        text: 'Cancel',
                        'class':'btn-formula-cancel btn-std-size btn-default hvr-glow normal-font',
                        click: () => {
                            this.dialog.dialog( "close" );
                            reject('MainFormulaModalView cancelled');
                        }
                    }
                ],
                close: () => {
                    listService.isUndoRedoEnabled = true;
                    this.dialog.dialog("destroy");
                    this.closeModal();
                },
                open: () =>{
                    this.renderList();
                    $('#formulaModal').closest('div.ui-dialog').append('<img id="modalResizeHandler" src="'+require("common/buttons/resize_handler.png")+'"/>');
                }
            });

            let datePicker = $( "#DateValue" );

            datePicker.datepicker({
                dateFormat: "d MM yy", 
                showOn: "button",
                buttonImageOnly: true, 
                buttonImage: require('common/icons/calendar.png'),
                'disabled': true
            });
            $("#DateValue").datepicker('disable');
            $("#DateValue ~ img").css('opacity',0.4);

            const firstItem = $('#formulaList div.formula-item')[0];
            $(firstItem).trigger('click');

            $('#btnAddLine').on('click', function (e) {
                let count = 0, selectedItem,  selectedIndex;
                if (this.multiSelectItemArray && this.multiSelectItemArray.length > 1){
                    selectedItem = self.findSelectedItemInArray(this.multiSelectItemArray[0].id);
                    selectedIndex = self.findIndexInParent(selectedItem);                    
                }else{
                    selectedItem = self.findSelectedItemInArray();
                    selectedIndex = self.findSelectedIndexInParent(selectedItem);                    
                }
                
                const parentArray = self.getItemParentArray(selectedItem);
                count = parentArray.length;

                    let newItem = {selectedItem: selectedItem, selectedIndex: selectedIndex};
                    if (selectedItem.kind === self.BLANK && count > 1) {
                        //selectedIndex--;
                        newItem = self.addOperator(selectedItem, selectedIndex);
                        selectedIndex++;
                        self.addLine(newItem.selectedItem, selectedIndex);
                    } else if (selectedItem.kind === self.BLANK && count === 1) {
                        self.addLine(newItem.selectedItem, selectedIndex);
                    }

                    if (selectedItem.kind === 'operator') {
                        //newItem = self.addOperator(selectedItem, selectedIndex);
                        selectedIndex = selectedIndex +2;
                        newItem = self.addOperator(selectedItem, selectedIndex);
                        selectedIndex++;
                        self.addLine(newItem.selectedItem, selectedIndex);
                    }
                    else if (selectedItem.kind !== self.BLANK) {
                        //newItem = self.addOperator(selectedItem, selectedIndex);
                        selectedIndex++;
                        newItem = self.addOperator(selectedItem, selectedIndex);
                        selectedIndex++;
                        self.addLine(newItem.selectedItem, selectedIndex);
                    }
            });

            $('#btnAddGrouping').on('click', function (e)  {
                self.addGrouping();
            });

            $('#btnRemoveGrouping').on('click', function (e) {
                self.removeGrouping();
            });

            $('#btnAddFunction').on('click', function(e) {
                let count = 0, selectedItem,  selectedIndex;
                if (this.multiSelectItemArray && this.multiSelectItemArray.length > 1){
                    selectedItem = self.findSelectedItemInArray(this.multiSelectItemArray[0].id);
                    selectedIndex = self.findIndexInParent(selectedItem);                    
                }else{
                    selectedItem = self.findSelectedItemInArray();
                    selectedIndex = self.findSelectedIndexInParent(selectedItem);                    
                }
                const parentArray = self.getItemParentArray(selectedItem);
                count = parentArray.length;

                if (count <= 2) {
                    let newItem = {selectedItem: selectedItem, selectedIndex: selectedIndex};
                    if (selectedItem.kind === self.BLANK && count > 1) {                        
                        newItem = self.addOperator(selectedItem, selectedIndex);
                        selectedIndex++;
                    }

                    if (selectedItem.kind === 'operator') {                        
                        selectedIndex = selectedIndex +2;
                        newItem = self.addOperator(selectedItem, selectedIndex);
                        selectedIndex++;                        
                    }else{
                    if (selectedItem.kind !== self.BLANK) {
                        selectedIndex++;
                        newItem = self.addOperator(selectedItem, selectedIndex);
                        selectedIndex++;
                       }
                     }

                    self.addFunction(newItem.selectedItem, selectedIndex);
                } else {
                    // Make sure we select the prior operator if we are not on one already.
                    /*if ((selectedItem.kind !== self.OPERATOR) && selectedIndex > 0 && selectedItem.kind !== 'blank') {
                        selectedIndex--;
                    }
                    selectedItem = parentArray[selectedIndex];*/
                    /*
                    if (selectedItem.parent !== self.FORMULA_LIST) {
                        selectedItem = selectedItem.parent.children[selectedIndex];
                    } else {
                        selectedItem = self.formulaExpression[selectedIndex];
                    }
                    */
                    //self.selectedId = selectedItem.id;
                    if (selectedItem.kind === 'operator') {
                        selectedIndex = selectedIndex +2;
                        let newItem = self.addOperator(selectedItem, selectedIndex);
                        selectedIndex++; 
                        self.addFunction(newItem.selectedItem, selectedIndex);
                    }else{
                    selectedIndex++;
                    let newItem = self.addOperator(selectedItem, selectedIndex);
                    selectedIndex++;
                    self.addFunction(newItem.selectedItem, selectedIndex);
                    }
                    //let newItem =  self.addFunction(selectedItem, selectedIndex);
                    //self.addOperator(newItem.selectedItem, newItem.selectedIndex);
                }
            });

            $('#TextOrNumberValue, #NumberValue, #TextValue, #DateValue, #SpecialValue').on('change', function (e) {
                self.updateArgument(e);
            });

            $('#TextOrNumberValue').on('keyup', function (e) {
                self.updateArgument(e);
            });
            
            $('input[type=radio]').on('change', function (e) {
                self.updateRadioAttributes(e);
            });

            $('#FormulaValueOfFieldButton').on('click', function (e) {
                self.showValueFieldModal(e);
            });     

            $('input[name=ValueOption]').on('click', function(e) {
                let disabled = $(this).val() !== 'DateValue';
                datePicker.datepicker( "option", "disabled", disabled );

                if(disabled){
                    $("#DateValue ~ img").css('opacity',0.4);
                }else{
                    $("#DateValue ~ img").css('opacity',1.0);
                }

            });

            $('#operatorList').on('change', function (e) {
                self.updateOperator(e);
            });

            $('#functionList').on('change', function(e) {
                self.updateFunction(e);
            });

            $('#formulaUp').on('click', function(e) {
                if (self.multiSelectItemArray && self.multiSelectItemArray.length > 1){
                    _.forEach(self.multiSelectItemArray, function(item) {
                        if (item.kind !== self.OPERATOR){
                            self.movePosition('up',item.id);
                        }
                    });                            
                }else{
                    self.movePosition('up');
                } 
               
            });

            $('#formulaDown').on('click', function(e) {
                if (self.multiSelectItemArray && self.multiSelectItemArray.length > 1){
                    for (var i = self.multiSelectItemArray.length-1; i > -1; i--) {   
                        if (self.multiSelectItemArray[i].kind !== self.OPERATOR){
                            self.movePosition('down',self.multiSelectItemArray[i].id);
                        }
                    }                            
                }else{
                    self.movePosition('down');
                } 
            });

            $('#deleteFormulaItem').on('click', function(e) {
                self.deleteItem();
                self.selectLastItem();
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});

            this.delegateEvents();
            $("#DateValue ~ img").css('opacity',0.4);
            return this;
        });
    }

    selectLastItem() {
        if (this.formulaExpression.length > 0) {
            $('#' + this.formulaExpression[this.formulaExpression.length - 1].id).click();
        }
    }

}

export default MainFormulaModalView;
